import { http } from "./http";

export const loadCitySettings = () =>
  http.get("/bulkyScheduler/city/settings").then((response) => {
    return response.data;
  });
